import { render, staticRenderFns } from "./OverlayLayer.vue?vue&type=template&id=da963c9c&lang=pug"
import script from "./OverlayLayer.vue?vue&type=script&lang=ts"
export * from "./OverlayLayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports